import { NavigationUserInfo } from './user-info.model';

// This takes an API response and transforms it into a User object
export function transformNavigationUserInfo(
  navigation: any,
): NavigationUserInfo {
  return {
    userId: navigation.id,
    username: navigation.username,
    publicName: navigation.publicName,
    isFreeTrialEligible: navigation.isFreeTrialEligible,
    isPlusTrialEligible: navigation.isPlusTrialEligible,
    trialPackageId: navigation.trialPackageId,
    isPremium: navigation.isPremium,
    logo: navigation.logo,
    membership: navigation.membership,
    hideMembershipUpgradeButton: navigation.hideMembershipUpgradeButton,
    trialDuration: navigation.trialDuration,
    trialLandingUrlParams: navigation.trialLandingUrlParams,
    monthlyTrial: navigation.monthlyTrial,
    canSwitchToUsers: navigation.canSwitchToUsers.map((u: any) => ({
      userId: u.user_id,
      publicName: u.publicName,
    })),
    isNoCommissionEligibleReferrer: navigation.isNoCommissionEligibleReferrer,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/@shared/datastore/navigation/user-info/user-info.transformers.ts